module.exports = __webpack_public_path__ + "img/2f36928caf84905d1385b77387eb178d.png";